import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=bd2e9046&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=js&"
export * from "./FormData.vue?vue&type=script&lang=js&"
import style0 from "./FormData.vue?vue&type=style&index=0&id=bd2e9046&prod&lang=scss&"
import style1 from "./FormData.vue?vue&type=style&index=1&id=bd2e9046&prod&lang=scss&scoped=true&"
import style2 from "./FormData.vue?vue&type=style&index=2&id=bd2e9046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2e9046",
  null
  
)

export default component.exports